import React, { useState } from "react";
import { DropdownButton } from "Components/DropdownButton";
import { SvgGear } from "melodies-source/Svgs/Gear";
import { UtmSourceEditorModal } from "./UtmSourceEditorModal";
import styled from "styled-components";
import { useMobileMediaQuery } from "hooks";

type ModalKey = "utm";

export const AdvancedSettings: React.FC = () => {
  const [modalKey, setModalKey] = useState<Nullable<ModalKey>>(null);
  const isMobile = useMobileMediaQuery();

  return (
    <Container>
      <DropdownButton
        leftIcon={<SvgGear />}
        menu={{
          items: [
            { label: "UTM Source Editor", onClick: () => setModalKey("utm") },
          ],
          placement: isMobile ? "bottom-start" : "bottom-end",
        }}
        text
      >
        Advanced Settings
      </DropdownButton>
      <UtmSourceEditorModal
        key={modalKey}
        isOpen={modalKey === "utm"}
        onClose={() => setModalKey(null)}
        variant="large"
      />
    </Container>
  );
};
const Container = styled.div`
  ${({ theme }) => theme.media.mobile} {
    align-self: flex-start;
  }
`;
